import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from 'src/components/components/index';
import { Routes } from 'src/constants/index';
import MasterClassesImg from 'src/assets/images/master-classes.jpg';
import './style.scss';

interface IProps {}

export class MasterClasses extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <div className="master-classes">
        <div className="master-classes__wrapper">
          <div className="master-classes__info-wrapper">
            <p className="master-classes__title">
              <FormattedMessage id="master.classes" />
            </p>
            <p className="master-classes__description">
              <FormattedMessage id="we.are.proud.to.offer.our.members" />
            </p>
            <p className="master-classes__description">
              <FormattedMessage id="be.included.in.our.future.classes" />
            </p>
            <div className="master-classes__btn-info">
              <p className="master-classes__btn-info-text">
                <FormattedMessage id="we.look.forward.to.seeing" />
              </p>
              <Link to={Routes.MasterClassesRegister} className="master-classes__btn-link">
                <BlueButton>
                  <FormattedMessage id="register" />
                </BlueButton>
              </Link>
            </div>
          </div>
          <div className="master-classes__img-wrapper">
            <img src={MasterClassesImg} alt="watch.videos" />
          </div>
        </div>
      </div>
    );
  }
}
